import { useState } from "react";
import unauthenticatedApi from "./unauthenticatedApi";
import api from "./api";
import { dismissAllToast, dismissToast, errorToast, loadingToastId } from "utils/Toast";
import LocalStorageUtils from "utils/LocalStorage";
import Constant from "utils/Constants";

export const BASE_API_CONSTANT = {
  METHOD: {
    POST: "POST",
    PUT: "PUT",
    GET: "GET",
    DELETE: "DELETE",
  },
};

const useBaseApiHook = (initialLoading = false, showError = true) => {
  const [isLoading, setIsLoading] = useState(initialLoading);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getDefaultHeaders = (isUnauthenticated) => {
    const token = LocalStorageUtils.jwtToken.get();
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(isUnauthenticated || !token ? {} : { Authorization: `Bearer ${token}` }),
    };
  };

  const executeApi = async (url, method, payload, axiosOptions = {}, checkToken = true) => {
    setIsLoading(true);
    const { isUnauthenticated = false } = axiosOptions;
    const _url = `${url}`;

    const newAxiosOptions = {
      ...axiosOptions,
      headers: {
        ...getDefaultHeaders(isUnauthenticated),
        ...axiosOptions.headers,
      },
    };

    try {
      let response;
      if (method === BASE_API_CONSTANT.METHOD.POST) {
        response = isUnauthenticated
          ? await unauthenticatedApi.post(_url, payload, newAxiosOptions)
          : await api.post(_url, payload, newAxiosOptions);
      } else if (method === BASE_API_CONSTANT.METHOD.GET) {
        response = isUnauthenticated
          ? await unauthenticatedApi.get(_url, newAxiosOptions)
          : await api.get(_url, newAxiosOptions);
      } else {
        throw new Error("Unsupported HTTP method");
      }

      setIsLoading(false);
      const resData = response?.data;

      // Return full response data (not just .data)
      setData(resData);
      return resData;
    } catch (e) {
      setIsLoading(false);
      setData(null);
      setError(e?.response?.data);
      dismissAllToast();

      if (e?.code === "ERR_NETWORK" || e?.message === "timeout exceeded") {
        errorToast("Cannot connect to server");
        return {
          success: false,
          isError: true,
          message: `Cannot connect to server. Reason: ${e?.message}`,
          error: e,
        };
      }

      if (showError) {
        const errMessage = e?.response?.data?.detail || e?.message || "Request failed";
        errorToast(errMessage);
      }

      return false;
    }
  };

  return {
    isLoading,
    data,
    error,
    executeApi,
  };
};

export default useBaseApiHook;
